export default __webpack_public_path__ + "static/media/depstore.5662fc91.svg";